import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';


@Injectable()
export class UsersService {
public myUrl = url + "users/";

constructor(private http:HttpClient){
    
}



public loginUsers(user:any){

    let headers=new HttpHeaders();
    let body=JSON.stringify(user);
    
    headers.append('Content-Type' , 'application/json');
    return this.http.post(this.myUrl+"/LoginUsers.php",body,{headers:headers}).pipe(map(data=>{
        return data;
    }));
}

public newLoginUsers(user: any){
    let headers = new HttpHeaders()
    let body = JSON.stringify(user)

    headers.append('Content-Type', 'application/json')
    return this.http.post(this.myUrl + '/LoginUsers.php', body, {headers: headers}).pipe(map(data => {
        return data;
    }))
}

getAllUsers(){
    let headers=new HttpHeaders();
  
    headers.append('Content-Type' , 'application/json');
    return this.http.get(this.myUrl+"getUsers.php",{headers:headers}).pipe(map(data=>{
        return data;
    }));  


}

getAllUsernames(){
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return this.http.get(this.myUrl + "getUsers.php", { headers: headers })
        .pipe(map((data: any) => {
            return data;
        }));
}

public getUserId(id){

    let headers=new HttpHeaders();
    let body=JSON.stringify({'id':id});
    
    headers.append('Content-Type','application/json');
    return this.http.post(this.myUrl+"/getUserId.php",body,{headers:headers}).pipe(map(data=>{
        return data;
    }));
}

public createUser(user){
 
    console.log("Service User",user);
    let headers=new HttpHeaders();
    let body=JSON.stringify(user);
    console.log("Service USer",body);
    headers.append('Content-Type' , 'application/json');

    return this.http.post(this.myUrl+"/createUsers.php",body,{headers:headers}).pipe(map(data=>{
        return data;
    }));
}
public createUserFile(user,file:File){
    const formData = new FormData();
    formData.append("fileUpload",file);
    formData.append("users",JSON.stringify(user));
    
    let headers=new HttpHeaders();
    let body=JSON.stringify(user);
    console.log("Service USer",body);
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Content-Type' , 'application/json');

    return this.http.post(this.myUrl+"createUsersFile.php",formData,{headers:headers}).pipe(map(data=>{
        return data;
    }));
}
public updateUser(user){

    let headers=new HttpHeaders();
    let body=JSON.stringify(user);
    // console.log(body);
    
     headers.append('Content-Type','application/json');
    return this.http.post(this.myUrl + "/updateUsers.php",body,{headers:headers}).pipe(map(data=>{
        return data;
    })); 
}

public updateUserFile(user,file:File){
    //console.log("service file ",file);
    
    const formData = new FormData();
    formData.append("fileUpload",file);
    formData.append("users",JSON.stringify(user));
    
    let headers=new HttpHeaders();
   
    //console.log("Service USer",body);
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Content-Type' , 'application/json');
    
    return this.http.post(this.myUrl+"updateUsersFile.php",formData,{headers:headers}).pipe(map(data=>{
        return data;
    }));
}


deleteUser(id){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    
    const params = new HttpParams()
    .set('id',id.toString());
    
    return this.http.delete(this.myUrl+"deleteUser.php",{params}).pipe(map(data=>{
      return data;
    }));
  }
  saveLog(data){
    let headers = new HttpHeaders();
    let body = JSON.stringify(data);
    headers.append("Content-Type", "application/json");

    return this.http
      .post(url + "generic/create.php?database=logs", body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      )
  }
}